<template></template>

<script>


import config from "../config/config.js";
import axios from "axios";
import moment from "moment";
import { Formio } from "formiojs";

export default {


    mounted() {
        Formio.setBaseUrl(config.API_URL + "/api/formManager");
        Formio.setProjectUrl(config.API_URL + "/api/formManager");
        Formio.createForm(
            document.getElementById("renderer"),
            newDefinition,
            {

                saveDraft: true,
                saveDraftThrottle: 10000,
                language: "de",
                i18n: translation

            }

        )
    }

}
</script>